import { ApiError } from '~/api/client'

/** ApiError면 사용자 메시지를, 아니면 fallback을 돌려준다. 전 화면 공통 사용. */
export function errMessage(err: unknown, fallback: string): string {
    return err instanceof ApiError ? err.message : fallback
}
